import { BroadcastChannel } from 'broadcast-channel';
import { BroadcastEvent, BroadcastEventType } from './broadcastHelper';


if (!BroadcastChannel) {
  console.error('BroadcastChannel is undefined');
}
export interface BroadcastService {
  addEventListener(eventListener: (event: BroadcastEvent) => void): void;

  postEvent(event: BroadcastEvent): void;
}

export class BroadcastChannelService implements BroadcastService {
  private readonly broadcastChannel = new BroadcastChannel<BroadcastEvent>('events');

  addEventListener(eventListener: (event: BroadcastEvent) => void): void {
    this.broadcastChannel.addEventListener('message', eventListener);
  }

  postEvent(event: BroadcastEvent): void {
    this.broadcastChannel
      .postMessage(event)
      .catch(() => console.error(`Error while posting ${BroadcastEventType[event.eventType]} event`));
  }
}

export class NullBroadcastService implements BroadcastService {
  addEventListener(eventListener: (event: BroadcastEvent) => void): void {
    // do nothing
  }

  postEvent(event: BroadcastEvent): void {
    // do nothing
  }
}